import type { PluginListenerHandle } from "@capacitor/core";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { registerPushNotificationsDeviceMutationOptions } from "../operations/register-push-notifications-device/registerPushNotificationsDeviceMutationOptions";
import { useEffect } from "react";
import { useLogger } from "@/logging/client/LoggerContext";

const pushNotificationsModule =
	import.meta.env.VITE_CAPACITOR_BUILD === "true"
		? import("@capacitor/push-notifications")
		: null;

export function PushNotificationsRegistrationListener() {
	const queryClient = useQueryClient();
	const registerDeviceMutation = useMutation(
		registerPushNotificationsDeviceMutationOptions(queryClient),
	);

	const logger = useLogger();

	useEffect(() => {
		if (!pushNotificationsModule) {
			return;
		}

		let registrationListenerHandle: PluginListenerHandle;
		pushNotificationsModule.then((m) => {
			m.PushNotifications.addListener("registration", (token) => {
				registerDeviceMutation.mutate(
					{
						params: {},
						search: {},
						body: {
							deviceToken: token.value,
						},
					},
					{
						onError: (e) => {
							logger.error(
								`Push Notification Register Device Mutation Error: ${e}`,
							);
						},
					},
				);
			}).then((handle) => {
				registrationListenerHandle = handle;
			});
		});
		let registrationErrorListenerHandle: PluginListenerHandle;
		pushNotificationsModule.then((m) =>
			m.PushNotifications.addListener("registrationError", (error) => {
				logger.error(`Push Notifications Registration Error: ${error}`);
			}).then((handle) => {
				registrationErrorListenerHandle = handle;
			}),
		);

		return () => {
			registrationListenerHandle?.remove();
			registrationErrorListenerHandle?.remove();
		};
	}, []);

	return null;
}
